import React from 'react';
import './CheckBox.css';

interface CheckboxComponentProps {
  isChecked?: boolean;
  onCheckboxChange: (checked: boolean) => void;
  disabled: boolean;
  className: string;
  checkBoxName?: string;
  placeCheckboxBefore?: boolean;
}

const CheckboxComponent: React.FC<CheckboxComponentProps> = ({
  isChecked,
  onCheckboxChange,
  disabled,
  checkBoxName,
  className,
  placeCheckboxBefore,
}) => {
  return (
    <div className={`custom_check_box ${className}`}>
      {placeCheckboxBefore && checkBoxName && (
        <label className="check_box_name_fromparent">{checkBoxName}</label>
      )}
      <input
        className={`styled-checkbox ${className}`}
        type="checkbox"
        checked={isChecked}
        disabled={disabled}
        onChange={(e) => onCheckboxChange(e.target.checked)}
      />
      {!placeCheckboxBefore && checkBoxName && (
        <label className="check_box_name_fromparent">{checkBoxName}</label>
      )}
    </div>
  );
};

export default CheckboxComponent;
